import { render } from "./editMaterialCompositionModal.vue?vue&type=template&id=3dee5dde&ts=true"
import script from "./editMaterialCompositionModal.vue?vue&type=script&lang=ts"
export * from "./editMaterialCompositionModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__